define.alias("shared/components/shared/wizards/device-setup/step-one", "media/components/shared/wizards/device-setup/step-one");